import { getSnapshot, Instance, isStateTreeNode, types } from "mobx-state-tree";
import { MessageWidgetConfig as ApiMessageWidgetConfig } from "@closerplatform/spinner-openapi";
import { WidgetConfigContext } from "@fidget/common/models/shared/spinner/types/messageWidgets/WidgetFormSubmissionWithWidget";

export const parseMessageWidgetConfig = <
  Widget extends IMessageWidgetConfig | ApiMessageWidgetConfig
>(
  widgetConfig: Widget
) => {
  const detachConfig = (config: IMessageWidgetConfig | ApiMessageWidgetConfig) => {
    if (isStateTreeNode(config)) {
      return getSnapshot(config);
    }
    return config;
  };

  const detachedConfig = detachConfig(widgetConfig);

  return {
    ...detachedConfig,
    config: {
      radioButtonsInputs: undefined,
      multipleButtonsInputs: undefined,
      radioListInputs: undefined,
      checkboxListInputs: undefined,
      textInputs: undefined,
      ...detachedConfig.config
    }
  };
};

export const MessageWidgetConfig = types.model("MessageWidgetConfig", {
  id: types.identifier,
  locale: types.string,
  name: types.string,
  tagGroupId: types.maybe(types.string),
  availableForAgents: types.boolean,
  config: types.frozen<WidgetConfigContext>()
});

export interface IMessageWidgetConfig extends Instance<typeof MessageWidgetConfig> { }
